export default import.meta.ROLLDOWN_FILE_URL_ckjhKFSPAdh_pUu$2yW7Fg